module.exports = __webpack_public_path__ + "static/14-SurveyImage-72d7c85512bdadf9b0b6391956a44175.png";